/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ViewWebShortlinkRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {ViewWebShortlinkResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const viewWebShortlink = (request: ViewWebShortlinkRequest, options?: CashRequestOptions) => post<ViewWebShortlinkRequest, ViewWebShortlinkResponse>("/2.0/cash/view-web-shortlink", request, {...options, rejectOnError: true })